import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LinkIcon from '@mui/icons-material/Link';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { addLineAction } from '_models/redux/add-line/action';
import { cleanAddLine } from '_models/redux/add-line/clean-action';
import { consultLegalIdAction } from '_models/redux/consult-legal-id/action';
import { cleanConsultLegalId } from '_models/redux/consult-legal-id/clean-action';
import { createIncodeLinksAction } from '_models/redux/create-incode-links/action';
import { cleanCreateIncodeLinks } from '_models/redux/create-incode-links/clean-action';
import { downloadPdfAction } from '_models/redux/download-pdf/action';
import { cleanDownloadPdf } from '_models/redux/download-pdf/clean-action';
import { getIncodeStatusAction } from '_models/redux/get-incode-status/action';
import { cleanIncodeStatus } from '_models/redux/get-incode-status/clean-action';
import { removeLineAction } from '_models/redux/remove-line/action';
import { cleanRemoveLine } from '_models/redux/remove-line/clean-action';
import { connect } from 'react-redux';
import { AddLineForm } from '../components/AddLineForm';
import { LegalInfoCard } from '../components/LegalInfoCard';
import { LinesList } from '../components/LinesList';
import { LinesPageDialogs } from '../components/LinesPageDialogs';
import { useManageLines } from '../hooks/useManageLines';
const LinesPage = ({
  addLine,
  addLineAction,
  cleanAddLine,
  removeLine,
  removeLineAction,
  cleanRemoveLine,
  createIncodeLinks,
  createIncodeLinksAction,
  cleanCreateIncodeLinks,
  getIncodeStatus,
  getIncodeStatusAction,
  cleanIncodeStatus,
  downloadPdf,
  downloadPdfAction,
  cleanDownloadPdf,
  consultLegalId,
  consultLegalIdAction,
  cleanConsultLegalId,
}) => {
  const {
    dataValidation,
    register,
    errors,
    addLineForm,
    handleSubmit,
    loading,
    lines,
    isDialogOpen,
    isIncodeStatusDialogLocked,
    dialogTitleMessage,
    dialogMessage,
    handleClose,
    icon,
    aditionalInfoDialog,
    generateIncodeLinks,
    isIncodeDialogOpen,
    incodeLinksDialog,
    handleCloseIncodeDialog,
    incodeLinksLoading,
    handleDeleteLine,
    isRemoveDialogOpen,
    handleCloseRemoveDialog,
    handleConfirmRemoveLine,
    pendingRemoveLine,
    formatPhoneNumber,
    navigateToAssignmentOrder,
    getIncodeStatusExecute,
    setValue,
  } = useManageLines({
    addLine,
    addLineAction,
    cleanAddLine,
    removeLine,
    removeLineAction,
    cleanRemoveLine,
    createIncodeLinks,
    createIncodeLinksAction,
    cleanCreateIncodeLinks,
    getIncodeStatus,
    getIncodeStatusAction,
    cleanIncodeStatus,
    downloadPdf,
    downloadPdfAction,
    cleanDownloadPdf,
    consultLegalId,
    consultLegalIdAction,
    cleanConsultLegalId,
  });
  return (
    <Box height={'90vh'} sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton sx={{ mr: 1 }} aria-label='Regresar' onClick={navigateToAssignmentOrder}>
          <ArrowBackIosIcon fontSize='small' />
        </IconButton>
        <Typography component='h4' variant='h6'>
          Vincular líneas telefónicas
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid container size={{ xs: 12 }} spacing={4}>
          <Grid size={{ xs: 12, sm: 12, md: 6 }} spacing={4}>
            <LegalInfoCard register={register} />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 6 }} spacing={4}>
            <AddLineForm
              register={register}
              errors={errors}
              dataValidation={dataValidation}
              handleSubmit={handleSubmit}
              addLineForm={addLineForm}
              loading={loading}
              setValue={setValue}
            />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <LinesList
            lines={lines}
            onDeleteLine={handleDeleteLine}
            formatPhoneNumber={formatPhoneNumber}
            loading={loading}
          />
        </Grid>
      </Grid>
      <Grid sx={{ mt: 'auto', pb: 4, width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Button
          variant='contained'
          startIcon={<LinkIcon />}
          style={{
            color: '#fff',
            backgroundColor: !lines.length ? '#ccc' : '#6242a2',
            width: '20rem',
          }}
          disabled={loading || !lines.length}
          onClick={generateIncodeLinks}
        >
          Vincular Líneas
        </Button>
      </Grid>
      <LinesPageDialogs
        dialogTitleMessage={dialogTitleMessage}
        dialogMessage={dialogMessage}
        icon={icon}
        isDialogOpen={isDialogOpen}
        handleClose={handleClose}
        isIncodeStatusDialogLocked={isIncodeStatusDialogLocked}
        aditionalInfoDialog={aditionalInfoDialog}
        pendingRemoveLine={pendingRemoveLine}
        formatPhoneNumber={formatPhoneNumber}
        isRemoveDialogOpen={isRemoveDialogOpen}
        handleCloseRemoveDialog={handleCloseRemoveDialog}
        handleConfirmRemoveLine={handleConfirmRemoveLine}
        loading={loading}
        isIncodeDialogOpen={isIncodeDialogOpen}
        handleCloseIncodeDialog={handleCloseIncodeDialog}
        incodeLinksDialog={incodeLinksDialog}
        incodeLinksLoading={incodeLinksLoading}
        getIncodeStatusExecute={getIncodeStatusExecute}
      />
    </Box>
  );
};

const mapStateToProps = (state) => ({
  addLine: state.addLine,
  removeLine: state.removeLine,
  createIncodeLinks: state.createIncodeLinks,
  getIncodeStatus: state.getIncodeStatus,
  downloadPdf: state.downloadPdf,
  consultLegalId: state.consultLegalId,
});

const mapDispatchToProps = {
  addLineAction,
  cleanAddLine,
  removeLineAction,
  cleanRemoveLine,
  createIncodeLinksAction,
  cleanCreateIncodeLinks,
  getIncodeStatusAction,
  cleanIncodeStatus,
  downloadPdfAction,
  cleanDownloadPdf,
  consultLegalIdAction,
  cleanConsultLegalId,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinesPage);
